import { render } from "./App.vue?vue&type=template&id=118c39ad&scoped=true"
const script = {}

import "./styles.scss?vue&type=style&index=0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=118c39ad&lang=scss&scoped=true"

import exportComponent from "/builds/customers/uid/trumpf-barcodes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118c39ad"]])

export default __exports__